import { DRSConfiguration, DRSRoute } from "../types/drs";

export const DEVELOPMENT_ROUTE_PREFIX = "[D]";

export const loadDevelopmentMicrofrontends = () => {
  const localStorageKeys = Object.keys(localStorage);
  const routes = [];

  localStorageKeys.forEach((key) => {
    if (key.split(":")[0] === "mf") {
      const item = JSON.parse(localStorage.getItem(key));

      localStorage.setItem(`import-map-override:${item.name}`, item.url);

      routes.push({
        name: `${DEVELOPMENT_ROUTE_PREFIX} ${key}`,
        available_interfaces: item.availableInterfaces || [],
        identifier: item.name,
        uri: item.url,
        icon: item.icon ?? "/icons/wrench.svg",
        is_header_enabled: item.isHeaderVisible ?? true,
        exact: item.exact ?? true,
        launch_point: item.path,
        url: item.path,
        is_redirect: item.isRedirect ?? false,
      });
    }
  });

  return routes;
};

export const getDevelopmentConfiguration = (microfrontends): DRSConfiguration => {
  const applications = microfrontends.map((microfrontend) => {
    return {
      identifier: microfrontend.identifier,
      uri: microfrontend.uri,
      available_interfaces: microfrontend.available_interfaces,
    };
  });

  return {
    applications,
  };
};

export const getDevelopmentRoutes = (microfrontends): DRSRoute[] => {
  const routes: DRSRoute[] = [];

  microfrontends.forEach((microfrontend) => {
    routes.push({
      application_identifier: microfrontend.identifier,
      order: 99999,
      name: microfrontend.name,
      assets: microfrontend.assets || "",
      path: microfrontend.url,
      icon: microfrontend.icon,
      launch_point: microfrontend.launch_point,
      access_roles: [],
      is_route_public: false,
      is_header_enabled: microfrontend.is_header_enabled,
      attached_to_menu: true,
      is_path_exact: microfrontend.exact,
      navigation_group: {
        name: "Developer routes",
        icon: "",
      },
      is_redirect: microfrontend.is_redirect || false,
    });
  });

  return routes;
};
